/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Image, ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Spinner from 'react-bootstrap/Spinner';
import { s } from '../../app/helper';
import fontStyles from '../text/Text.module.css';
import styles from './ReportPreviewCard.module.css';
import { SmallSecondaryButton, SmallSecondaryOutlineButton } from '../button/Button';
import { getJob, Job, JobStatus } from '../../app/job';
import { IReport, selectThumbnail, setActiveReportId } from '../../reducer/reportsSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

// TODO: periodic polling? or is it not needed anymore?
const ReportStatusBanner: React.FC<{ report: IReport }> = ({ report }) => {
  const [job, setJob] = useState<Job | null>(null);
  const [t] = useTranslation('report_card');

  const fetchJob = (jobid: string): void => {
    getJob(jobid).then((j) => setJob(j));
  };

  useEffect(() => {
    // query the job for the first time
    fetchJob(report.job_id);
  }, [report]);

  useEffect(() => {
    // schedule refresh of job data
    const timeout = setTimeout(
      () => { fetchJob(report.job_id); },
      10000,
    );
    // cleaning up timeout
    return () => { clearTimeout(timeout); };
  }, [job, report]);

  if (job === null) {
    return null;
  }

  let content = null;
  if (job.status === JobStatus.QUEUED) {
    content = t('queued');
  } else if (job.status === JobStatus.STARTED || job.status === JobStatus.FINISHED) {
    // running
    content = (
      <>
        {job.status === JobStatus.STARTED ? t('running') : t('done')}
        <ProgressBar className={s(styles.cardProgress)}>
          <ProgressBar className={s(styles.cardProgressFill)} now={job.progress} />
        </ProgressBar>
      </>
    );
  } else {
    // error
    content = t('error');
  }

  return (
    <div className={s(styles.reportCardBanner, fontStyles.text)}>
      {content}
    </div>
  );
};

interface IReportPreviewCardProps {
  report: IReport,
  showReportPreview:()=>void,
}

const ReportPreviewCard: React.FC<IReportPreviewCardProps> = ({ report, showReportPreview }) => {
  const dispatch = useAppDispatch();
  const [t] = useTranslation('report_card');
  const imageURL = useAppSelector((state) => selectThumbnail(state, report.job_id));
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  const showBanner = false; // TODO !report.available;

  return (
    <Card
      className={s(styles.reportCard)}
    >
      <Image
        className={styles.thumbnail}
        src={imageURL}
        onLoad={() => { setImageLoaded(true); }}
      />
      {imageLoaded ? null : (
        <>
          <Spinner animation="border" />
          <div style={{ zIndex: 0 }}>Loading...</div>
        </>
      )}
      { showBanner && (
        <ReportStatusBanner report={report} />
      )}
      <div className={styles.reportCardContent}>
        <div className={s(styles.reportTitle, fontStyles.SubHeaderPopups)}>{report.company}</div>
        <div className={s(styles.reportSubTitle, fontStyles.text)}>{report.year}</div>
        <div className={styles.buttonBar}>
          <SmallSecondaryOutlineButton onClick={() => {
            dispatch(setActiveReportId(report.job_id));
            showReportPreview();
          }}
          >
            {t('preview')}
          </SmallSecondaryOutlineButton>
          <SmallSecondaryButton
            onClick={() => {
              dispatch(setActiveReportId(report.job_id));
              navigate(`/report/${report.job_id}/`);
            }}
          >
            {t('select')}
          </SmallSecondaryButton>
        </div>
      </div>
    </Card>
  );
};

export default ReportPreviewCard;

type ReportPreviewAddProps = {
  onClick: () => void;
};

export const ReportPreviewAdd: React.FC<ReportPreviewAddProps> = ({ onClick }) => {
  const [t] = useTranslation('report_card');
  return (
    <Card className={s(styles.reportCard, styles.addCard)} onClick={onClick}>
      <FontAwesomeIcon icon={faPlus} size="2x" />
      <div className={s(fontStyles.text, styles.addDocText)}>{t('add-document')}</div>
    </Card>
  );
};
